module.exports = __webpack_public_path__ + "static/media/BOSCH_RGB.9bd665cd.png";